export const STORE_REGISTRY_LOCATOR_TOKEN = Symbol.for('mcp.store.registry_locator');
export const STORE_SCOPE_RESOLVER_TOKEN = Symbol.for('mcp.store.scope_resolver');
export const STORE_DRIVER_TOKEN = Symbol.for('mcp.store.driver');
